import styled from "styled-components";

import colors from "../../../assets/css/colors";

export const Label = styled.div`
	font-size: ${({ small_label }) => small_label ? "16px" : "20px"};
	color: ${colors.primary.primary};
`;

export default Label;